import React, { useState, useCallback, useEffect } from 'react';
import DataGrid, {
  ColumnChooser,
  ColumnFixing,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Scrolling,
  SearchPanel,
  Selection,
  Summary,
  GroupItem,
  TotalItem,
  FilterPanel,
  Sorting,
  FilterRow,
  Column
} from 'devextreme-react/data-grid';
import { StateStoring } from 'devextreme-react/pivot-grid';
import { Template, Button } from 'devextreme-react';
import { Switch } from 'devextreme-react/switch';
import devices from 'devextreme/core/devices';
import { formatMessage } from 'devextreme/localization';
import styles from './datagridmvp.module.scss';
import DateRangePicker from '../DateRangePicker';
import PopupQRCode from '../PopupQRCode';
import { replaceString } from '../../utils/functions';
import CustomFooter from './components/CustomFooter';

const DataGridMVP = ({
  children,
  setStateStoringName,
  setDataGridInstance = () => {},
  dataSource,
  onEditorPreparing,
  onSelectionChanged,
  onCellPrepared,
  additionalFooterData = false,
  filterDataGrid = { dateFrom: '', dateTo: '' },
  setFilterDataGrid,
  className,
  onSearchChanged = () => {},
  altWeightNettoField = 'nett',
  altWeightBruttoField = 'gross',
  showSumCount = true,
  showSumNetto = true,
  showSumBrutto = true,
  onCellClick,
  onRowUpdated,
  dataGridOnOptionChanged,
  tText,
  isDataLoading,
  isUnique = false,
  visibleActyalButton = false,
  visibleButtonAddResponsiblePerson = false,
  visibleButtonAddHolderReport = false,
  visibleButtonCheckAll = false,
  visibleButtonConfirmTn = false,
  visibleButtonDateRangePicker = true,
  visibleButtonPersonVisit = false,
  visibleButtonQRCode = false,
  visibleButtonSelectFields = false,
  visibleButtonUpdate = false,
  visibleButtonDeleteContract = false,
  visibleButtonDeleteTn = false,
  visibleButtonUpdateContract = false,
  visibleButtonEditTn = false,
  visibleColumnChooser = true,
  visibleFilter = true,
  visibleFilterPanel = true,
  visibleGroupPanel = true,
  visibleHeaderFilter = true,
  visibleInfoIcon = true,
  visibleSearchPanel = true,
  visibleSummary = true,
  keyExpr = 'pieceNumId',
  onClickUpdate,

  scrollingMode = 'virtual',

  selectionMode = 'multiple',
  selectedRowKeys,
  focusedRowEnabled,
  onFilterChanged = () => {},
  focusedRowIndex,
  onFocusedRowChanged,
  outerDataForFooter = null, // Доступно к привязке в футере
  units = 'tonne', // Единицы измерения в футере
  shrinkToolbar = false,
  modalSelectFieldsOpen
}) => {
  const [footerSumCount, setFooterSumCount] = useState(0);
  const [footerSumSumNetto, setFooterSumSumNetto] = useState(0);
  const [footerSumSumBrutto, setFooterSumSumBrutto] = useState(0);
  const [combinedFilter, setCombinedFilter] = useState(null);

  const [footerSumCountR, setFooterSumCountR] = useState(0);
  const [footerSumSumNettoR, setFooterSumSumNettoR] = useState(0);
  const [footerSumSumBruttoR, setFooterSumSumBruttoR] = useState(0);
  const [footerSumSelectedColumn, setFooterSumSelectedColumn] = useState(0);
  // const [footerSelectedColumnName, setFooterSelectedColumnName] = useState('');
  const [footerSelectedColumnData, setFooterSelectedColumnData] = useState({
    column: null,
    caption: null,
    sum: null
  });

  const [refD, setRefD] = useState({});

  const [multiStringSearch, setMultiStringSearch] = useState('');

  const setFooterData = useCallback((gridDataSource) => {
    const temp = {
      count: 0,
      sumNetto: 0,
      sumBrutto: 0
    };
    gridDataSource.forEach((item) => {
      const supplement = outerDataForFooter ? item.weight : 1;
      temp.count += supplement;
      temp.sumNetto += parseFloat(altWeightNettoField === 'nett'
        ? item.weightNetto
        : item[altWeightNettoField] === null
          ? 0
          : item[altWeightNettoField]);
      temp.sumBrutto += parseFloat(altWeightBruttoField === 'gross'
        ? item.weightBrutto
        : item[altWeightBruttoField] === null
          ? (altWeightBruttoField.toUpperCase().includes('ОСТ.') || altWeightBruttoField.toUpperCase().includes('REMAIN'))
            ? item[altWeightNettoField]
            : 0
          : item[altWeightBruttoField]);
    });
    setFooterSumCount(temp.count);
    setFooterSumSumNetto(temp.sumNetto);
    setFooterSumSumBrutto(temp.sumBrutto);
  }, [altWeightBruttoField, altWeightNettoField, outerDataForFooter]);

  const setFooterDataR = useCallback((data) => {
    setFooterSumCount(data.count);
    setFooterSumSumNetto(data.sumNetto);
    setFooterSumSumBrutto(data.sumBrutto);
  }, []);

  // todo подумать над лучшей реализацией подсчета итогов
  const functionDataGrid = useCallback((ref) => {
    setDataGridInstance(ref);
    setRefD(ref);
    if (ref) {
      const selectDataSource = outerDataForFooter ? dataSource
        .filter((item) => selectedRowKeys.includes(item.pieceNumId))
        : isUnique
          // eslint-disable-next-line max-len,no-shadow
          ? dataSource.filter((item) => Array.from(new Set(ref.instance.getSelectedRowsData().map((item) => item.readyPieceNumId).flat())).includes(item.readyPieceNumId))
          : ref.instance.getSelectedRowsData();
      if (selectDataSource.length > 0) {
        setFooterData(selectDataSource);
      } else {
        setFooterDataR({
          count: footerSumCountR,
          sumNetto: footerSumSumNettoR,
          sumBrutto: footerSumSumBruttoR
        });
      }
    }
  }, [
    isUnique,
    footerSumCountR,
    footerSumSumBruttoR,
    footerSumSumNettoR,
    setDataGridInstance,
    setFooterData,
    setFooterDataR,
    outerDataForFooter,
    dataSource,
    selectedRowKeys
  ]);

  const onContentReady = useCallback((e) => {
    if (combinedFilter !== null
      && (JSON.stringify(combinedFilter) !== JSON.stringify(e.component.getCombinedFilter()))) {
      onFilterChanged();
      setCombinedFilter(e.component.getCombinedFilter());
    } else {
      setCombinedFilter(e.component.getCombinedFilter());
    }
    if (filterDataGrid && filterDataGrid.filter !== '' && visibleSearchPanel) {
      setTimeout(document.getElementsByClassName('dx-datagrid-search-panel')[0].children[0].getElementsByClassName('dx-texteditor-input')[0].focus(), 200);
    }
    /** для скролла таблицы при перемещении столбца источник:
     * https://supportcenter.devexpress.com/ticket/details/t921393/treelist-reorder-columns-using-drag-and-drop-does-scroll-the-grid-horizontally
     * https://codesandbox.io/s/t921393-9d8h6?file=/src/app/app.component.ts:788-1173 */
    // const headers = e.element.querySelectorAll('.dx-header-row > td');
    // const t = this;
    // headers.forEach((element) => {
    //   console.log(element);
    //   // console.log(element);
    //   off(element, 'dxdrag', t.dragHandler);
    //   on(element, 'dxdrag', { component: e.component }, t.dragHandler);
    // });
    //
    // e.component.option('loadPanel.enabled', false);
  }, [combinedFilter, filterDataGrid, onFilterChanged, visibleSearchPanel]);

  useEffect(() => {
    const handleGlobalPaste = (e) => {
      const activeEl = document.activeElement;
      const isSearchInput =
        activeEl?.classList?.contains('dx-texteditor-input') &&
        activeEl.closest('.dx-searchbox');
      if (isSearchInput) {
        const clipboardText = e.clipboardData?.getData('text') || '';
        if (clipboardText.includes('\n') || clipboardText.includes('\r') || clipboardText.includes('\t')) {
          e.preventDefault();
          const singleLine = clipboardText
            .split(/[\r\n\t]/)
            .map(line => line.trim())
            .filter(line => line.length > 0)
            .join(';');
          if (singleLine) {
            document.execCommand('insertText', false, singleLine);
            if (typeof dataGridOnOptionChanged === 'function') {
              dataGridOnOptionChanged({
                value: singleLine,
                name: 'searchPanel'
              });
            }
            setMultiStringSearch(singleLine);
          }
        }
      }
    };
    document.addEventListener('paste', handleGlobalPaste);
    return () => document.removeEventListener('paste', handleGlobalPaste);
  }, [dataGridOnOptionChanged]);

  const onOptionChanged = useCallback(({ value, name, fullName, component }) => {
    if (dataGridOnOptionChanged && name === 'searchPanel') {
      if (value === null || value === '') {
        setMultiStringSearch('');
      }
      if ((value && value.length >= 3 && multiStringSearch === '') || value === null || value === '') {
        setTimeout(() => {
          refD.instance.searchByText(replaceString(value.trim()));
          dataGridOnOptionChanged({
            value: replaceString(value.trim()),
            name
          });
        }, 200);
      }
    }
    if (fullName === 'searchPanel.text') {
      onSearchChanged();
    }

    if (
      name === 'filterBuilderPopup'
      && fullName === 'filterBuilderPopup.visible'
    ) {
      component.on('optionChanged', (e) => {
        if (e.name === 'filterValue' && e.value) {
          if (Array.isArray(e.value[0])) {
            e.value = e.value.map((el) => {
              if (Array.isArray(el) && el[0] === 'weightNetto') {
                // eslint-disable-next-line no-param-reassign
                el[2] = Math.abs(el[2]);
                return el;
              }
              return el;
            });
          } else if (e.value[0] === 'weightNetto') {
            e.value[2] = Math.abs(e.value[2]);
          }
        }
      });
    }
  }, [dataGridOnOptionChanged, multiStringSearch, onSearchChanged, refD.instance]);

  const calculateCustomSummary = useCallback((options) => {
    if (options.name === 'psStatusName') {
      // eslint-disable-next-line default-case
      switch (options.summaryProcess) {
        case 'start':
          // eslint-disable-next-line no-param-reassign
          options.totalValue = 0;
          break;
        case 'calculate':
          // eslint-disable-next-line no-param-reassign
          options.totalValue += 1;
          break;
        case 'finalize':
          setFooterSumCount(options.totalValue);
          setFooterSumCountR(options.totalValue);
          break;
      }
    }
    if (options.name === 'weightNettoField') {
      // eslint-disable-next-line default-case
      switch (options.summaryProcess) {
        case 'start':
          // eslint-disable-next-line no-param-reassign
          options.totalValue = 0;
          break;
        case 'calculate':
          // eslint-disable-next-line no-param-reassign
          options.totalValue += parseFloat(options.value);
          // eslint-disable-next-line no-param-reassign
          options.totalValue = +options.totalValue.toFixed(3);
          break;
        case 'finalize':
          setFooterSumSumNetto(options.totalValue);
          setFooterSumSumNettoR(options.totalValue);
          break;
      }
    }
    if (options.name === 'weightBruttoField') {
      // eslint-disable-next-line default-case
      switch (options.summaryProcess) {
        case 'start':
          // eslint-disable-next-line no-param-reassign
          options.totalValue = 0;
          break;
        case 'calculate':
          // eslint-disable-next-line no-param-reassign
          options.totalValue += parseFloat(options.value);
          // eslint-disable-next-line no-param-reassign
          options.totalValue = +options.totalValue.toFixed(3);
          break;
        case 'finalize':
          setFooterSumSumBrutto(options.totalValue);
          setFooterSumSumBruttoR(options.totalValue);
          break;
      }
    }
    if (footerSelectedColumnData.column && (options.name === footerSelectedColumnData.column)) {
      // eslint-disable-next-line default-case
      switch (options.summaryProcess) {
        case 'start':
          // eslint-disable-next-line no-param-reassign
          options.totalValue = 0;
          break;
        case 'calculate':
          // eslint-disable-next-line no-param-reassign
          options.totalValue += parseFloat(options.value);
          break;
        case 'finalize':
          setFooterSumSelectedColumn(options.totalValue.toFixed(3));
          break;
      }
    }
  }, [footerSelectedColumnData.column]);

  /** Работа с панелью сверху */
  const onSelectEnd = useCallback((startDate, endDate) => {
    setFilterDataGrid({ ...filterDataGrid, dateFrom: startDate, dateTo: endDate });
  }, [filterDataGrid, setFilterDataGrid]);

  const toolbarItemRender = useCallback(() => (
    <DateRangePicker onSelectEnd={onSelectEnd}
                     tFormat="yyyy-MM-dd"
                     tStartDate={filterDataGrid.dateFrom}
                     tEndDate={filterDataGrid.dateTo}
                     tText={tText}
    />
  ), [filterDataGrid.dateFrom, filterDataGrid.dateTo, onSelectEnd, tText]);

  // todo Работа с QRCode
  const [visibleModalQRCode, setVisibleModalQRCode] = useState(false);

  // нажатие на кнопку сканирования QR-кодов в тулбаре
  const onClickQRCode = useCallback(() => {
    setVisibleModalQRCode(true);
  }, [setVisibleModalQRCode]);

  // закрытие модальки сканирования QR-кодов
  const onCloseQRCode = useCallback((e) => {
    setVisibleModalQRCode(e);
  }, []);

  // кнопка сканирования QR-кодов в тулбаре
  const toolbarItemQRCode = useCallback(() => (
    <Button icon={(window.localStorage.getItem('theme') && window.localStorage.getItem('theme') === 'material.blue.dark' ? '/images/qrcode_dark.png' : '/images/qrcode.png')}
            stylingMode="text"
            onClick={onClickQRCode}
    />
  ), [onClickQRCode]);

  // кнопка обновления данных
  const toolbarUpdate = useCallback(() => (
    <Button icon="refresh"
            type="default"
            stylingMode="text"
            onClick={onClickUpdate}
            hint="Обновить"
    />
  ), [onClickUpdate]);

  // кнопка выбора полей таблицы
  const toolbarSelectFields = useCallback(() => (
    <Button icon="menu"
            type="default"
            stylingMode="text"
            onClick={() => {
              const regex = /dataGrid(\w+?)(Consignment|Recycling)?(\d+)$/;
              const match = setStateStoringName.match(regex);
              if (match) {
                modalSelectFieldsOpen({
                  gridName: match[1],
                  plantType: match[2] || '',
                  plantId: match[3],
                  storingName: setStateStoringName // потом убрать пока для проверки содержимого
                });
              }
            }}
            hint="Выбор столбцов"
    />
  ), [modalSelectFieldsOpen, setStateStoringName]);

  // todo Добавление чекбокса на все элементы
  const toolbarItemActyalButton = useCallback(() => (
    <div className={styles.toolbarItemActyalButton}>
      <div className="dx-field">
        <div className="dx-field-label">{formatMessage('textButton').all}</div>
        <div className="dx-field-value">
          <Switch value={!filterDataGrid.actual}
                  onValueChanged={({ value }) => setFilterDataGrid({
                    ...filterDataGrid,
                    actual: (value ? 0 : 1)
                  })}
                  switchedOffText={formatMessage('textButton').all}
                  switchedOnText={formatMessage('textButton').no}
          />
        </div>
      </div>
    </div>
  ), [filterDataGrid, setFilterDataGrid]);

  const onToolbarPreparing = useCallback((toolbar) => {
    // const removed = toolbar.toolbarOptions.items.splice(visibleGroupPanel ? 3 : 2);
    // console.log('removed =', removed);
    // toolbar.toolbarOptions.items.splice(visibleGroupPanel ? 1 : 0, 0, removed[0]);
    // console.log('toolbar =', toolbar);
    if (visibleButtonAddHolderReport) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonAddHolderReport'
      });
    }
    if (visibleButtonAddResponsiblePerson) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonAddResponsiblePerson'
      });
    }
    if (visibleButtonPersonVisit) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonVisitResponsiblePerson'
      });
    }
    if (visibleButtonDeleteContract) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonDeleteContract'
      });
    }
    if (visibleButtonUpdateContract) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonUpdateContract'
      });
    }
    if (visibleButtonEditTn) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonEditTn'
      });
    }
    if (visibleButtonDeleteTn) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonDeleteTn'
      });
    }
    if (visibleButtonConfirmTn) {
      toolbar.toolbarOptions.items.push({
        location: 'before',
        template: 'toolbarButtonConfirmTn'
      });
    }
    if (visibleButtonDateRangePicker) {
      toolbar.toolbarOptions.items.push({
        location: 'after',
        template: 'totalGroupCount'
      });
    }
    if (visibleButtonUpdate) {
      toolbar.toolbarOptions.items.push({
        location: 'after',
        template: 'toolbarUpdate'
      });
    }
    if (visibleButtonQRCode && devices.current().deviceType === 'desktop') {
      toolbar.toolbarOptions.items.splice(1, 0, {
        location: 'after',
        template: 'totalQRCode'
      });
    }
    if (visibleActyalButton) {
      toolbar.toolbarOptions.items.splice(1, 0, {
        location: 'after',
        template: 'toolbarItemActyalButton'
      });
    }
    if (!visibleSearchPanel) {
      const panelIndex = toolbar.toolbarOptions.items.findIndex((el) => el.name === 'searchPanel');
      toolbar.toolbarOptions.items.splice(panelIndex, 1);
    }
    if (visibleButtonSelectFields) {
      toolbar.toolbarOptions.items.push({
        location: 'after',
        template: 'toolbarSelectFields'
      });
    }
  }, [visibleButtonAddResponsiblePerson,
    visibleButtonAddHolderReport,
    visibleButtonDateRangePicker,
    visibleButtonUpdate, visibleButtonQRCode,
    visibleActyalButton, visibleButtonPersonVisit,
    visibleSearchPanel, visibleButtonDeleteContract,
    visibleButtonUpdateContract, visibleButtonEditTn,
    visibleButtonDeleteTn, visibleButtonConfirmTn,
    visibleButtonSelectFields]);

  const openInfo = useCallback((data) => {
    const newWindow = window.open(`/info/${data.data.pieceNumId}`, '_blank');
    newWindow.opener = null;
  }, []);

  // дополнительная кнопка расчета веса выбранной колонки в контекстном меню
  const addHeaderSumButtonMenu = useCallback((e) => {
    if (e.target === 'header' && e.column.dataType === 'number') {
      const item = { text: 'Рассчитать сумму',
        onClick: () => {
          setFooterSelectedColumnData({
            column: e.column.dataField,
            caption: e.column.caption
          });
        }
      };
      e.items.push(item);
    }
  }, []);

  const cellRenderButtonInfo = useCallback((data) => (
    <>
      <Button type="default"
              stylingMode="text"
              elementAttr={{ class: styles.infoButton }}
              onClick={() => openInfo(data)}
              icon={
              (window.localStorage.getItem('theme')
                && window.localStorage.getItem('theme') === 'material.blue.dark'
                ? (data.data.trackingInfoFlag === 'Y'
                  ? '/images/information-button-gps_dark.svg'
                  : '/images/information-button_dark.svg')
                : (data.data.trackingInfoFlag === 'Y'
                  ? '/images/information-button-gps.svg'
                  : '/images/information-button.svg'))
              }
      />
      <Button type="default"
              stylingMode="text"
              onClick={() => openInfo(data)}
              icon={
              (window.localStorage.getItem('theme')
              && window.localStorage.getItem('theme') === 'material.blue.dark'
                ? (data.data.hasAttachment === 'Y'
                  ? '/images/information-photo_dark.svg'
                  : '/images/information-none.svg')
                : (data.data.hasAttachment === 'Y'
                  ? '/images/information-photo.svg'
                  : '/images/information-none.svg'))
              }
      />
    </>
  ), [openInfo]);

  // Управление колесом прокрутки
  useEffect(() => {
    if (typeof isDataLoading !== 'undefined' && Object.keys(refD).length) {
      if (isDataLoading) {
        refD.instance.beginCustomLoading();
      } else {
        refD.instance.endCustomLoading();
      }
    }
  }, [isDataLoading, refD]);

  // todo при группировке убрать запятую в сумме
  return (
    <div className={styles.containing}>
      <div className={styles.main}>
        <DataGrid ref={(ref) => functionDataGrid(ref)}
                  dataSource={dataSource}
                  elementAttr={{ class: `${styles.dataGrid} ${className} ${!visibleButtonCheckAll && styles.buttonCheckAll}` }}
                  showBorders
                  hoverStateEnabled
                  columnAutoWidth
                  allowColumnReordering
                  onEditorPreparing={onEditorPreparing}
                  allowColumnResizing
                  rowAlternationEnabled
                  onSelectionChanged={onSelectionChanged}
                  onOptionChanged={onOptionChanged}
                  onToolbarPreparing={onToolbarPreparing}
                  onRowUpdated={onRowUpdated}
                  onCellPrepared={onCellPrepared}
                  onCellClick={onCellClick}
                  onFocusedRowChanged={onFocusedRowChanged}
                  onContextMenuPreparing={addHeaderSumButtonMenu}
                  // renderAsync
                  // repaintChangesOnly
                  onContentReady={onContentReady}
                  keyExpr={keyExpr}
                  twoWayBindingEnabled={false}
                  columnResizingMode="widget"
                  cacheEnabled
                  selectedRowKeys={selectedRowKeys}
                  focusedRowEnabled={focusedRowEnabled}
                  focusedRowIndex={focusedRowIndex}
                  touchEnabled={false}
          // grouping={{
                  //   autoExpandAll: false
                  // }}
          // scrolling={{
                  //   showScrollbar: 'always',
                  //   // columnRenderingMode: 'virtual',
                  //   mode: 'virtual',
                  //   useNative: false
                  // }}
        >
          {/* <LoadPanel shadingColor={'rgba(0,0,0,0.4)'}
                     showPane
                     shading={false}
                     showIndicator
                     enabled
          /> */}
          <FilterPanel visible={visibleFilterPanel} />
          <FilterRow visible={visibleFilter} />
          <StateStoring enabled type="localStorage" storageKey={setStateStoringName} />
          <Selection mode={selectionMode}
                     selectAllMode="allPages"
                     showCheckBoxesMode="always"
          />
          <Sorting mode="multiple" />
          <ColumnChooser enabled={visibleColumnChooser} />
          <ColumnFixing enabled />
          <Export enabled
                  fileName="Export"
                  texts={{ exportAll: formatMessage('textDataGrid').exportExcel }}
                  allowExportSelectedData />
          <HeaderFilter visible={visibleHeaderFilter} />
          <Grouping autoExpandAll={false} />
          <GroupPanel visible={visibleGroupPanel} />
          <Scrolling mode={scrollingMode} />
          <SearchPanel visible
                       width={shrinkToolbar ? 160 : 240}
                       onValueChanged={onSearchChanged}
                       placeholder={`${formatMessage('textDataGrid').textSearch}...`}
          />
          {/* Фиксированный столбец для получения развернутой информации */}
          {(visibleInfoIcon
            ? (
              <Column fixed
                      width={80}
                      cssClass="td-button-cell-render"
                      cellRender={cellRenderButtonInfo}
                      caption="INFO"
              />
            )
            : '')}
          {children}
          <Summary calculateCustomSummary={calculateCustomSummary}
                   recalculateWhileEditing
          >
            <GroupItem column="psStatusName"
                       summaryType="count"
                       displayFormat={`${formatMessage('textDataGrid').pieceQU}: {0}`} />
            <GroupItem column={altWeightNettoField === 'nett' ? 'weightNetto' : altWeightNettoField}
                       summaryType="sum"
                       valueFormat="decimal"
                       displayFormat={`${formatMessage('textDataGrid').textTotal}: ${formatMessage('textDataGrid').nett} – {0} ${formatMessage('textDataGrid').tonne}`}
                       showInGroupFooter={false}
            />
            <GroupItem column={altWeightBruttoField === 'gross' ? 'weightBrutto' : altWeightBruttoField}
                       summaryType="sum"
                       valueFormat="decimal"
                       displayFormat={`${formatMessage('textDataGrid').gross} – {0} ${formatMessage('textDataGrid').tonne}`}
                       showInGroupFooter={false}
            />
            <TotalItem column="psStatusName"
                       summaryType="custom"
                       name="psStatusName"
            />
            <TotalItem column={altWeightNettoField === 'nett' ? 'weightNetto' : altWeightNettoField}
                       summaryType="custom"
                       name={'weightNettoField'}
            />
            <TotalItem column={altWeightBruttoField === 'gross' ? 'weightBrutto' : altWeightBruttoField}
                       summaryType="custom"
                       name={'weightBruttoField'}
            />
            <TotalItem column={footerSelectedColumnData.column}
                       summaryType="custom"
                       name={footerSelectedColumnData.column}
            />
          </Summary>
          <Template name="totalGroupCount" render={toolbarItemRender} />
          <Template name="totalQRCode" render={toolbarItemQRCode} />
          <Template name="toolbarItemActyalButton" render={toolbarItemActyalButton} />
          <Template name="toolbarUpdate" render={toolbarUpdate} />
          <Template name="toolbarSelectFields" render={toolbarSelectFields} />
        </DataGrid>
      </div>
      <CustomFooter
        outerDataForFooter={outerDataForFooter}
        visibleSummary={visibleSummary}
        footerSumCount={footerSumCount}
        footerSelectedColumnData={footerSelectedColumnData}
        footerSumSelectedColumn={footerSumSelectedColumn}
        altWeightNettoField={altWeightNettoField}
        altWeightBruttoField={altWeightBruttoField}
        showSumCount={showSumCount}
        showSumNetto={showSumNetto}
        showSumBrutto={showSumBrutto}
        footerSumSumNetto={footerSumSumNetto}
        footerSumSumBrutto={footerSumSumBrutto}
        units={units}
        additionalFooterData={additionalFooterData}
      />
      <div className={styles.buttonQR} style={{ display: (visibleButtonQRCode && devices.current().deviceType !== 'desktop' ? 'block' : 'none') }}>
        <Button icon={(window.localStorage.getItem('theme') && window.localStorage.getItem('theme') === 'material.blue.dark' ? '/images/qrcode.png' : '/images/qrcode.png')}
                stylingMode="contained"
                type="default"
                width={100}
                height={100}
                onClick={onClickQRCode}
        />
      </div>
      <PopupQRCode visible={visibleModalQRCode}
                   onClose={onCloseQRCode}
                   filterDataGrid={filterDataGrid}
      />
    </div>
  );
};

export default React.memo(DataGridMVP);
